import { render } from "./Tenants.vue?vue&type=template&id=b5776736&ts=true"
import script from "./Tenants.vue?vue&type=script&lang=ts"
export * from "./Tenants.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__